import { Shift } from "../../../../models";
import { DataAPI_Base } from "../base";

export class ShiftsAPI extends DataAPI_Base<Shift> {
	constructor() {
		super("shifts", Shift);
	}
}
